angular.module('mercury.modules.reports.reconciliations')
.controller('ReportsReconciliationOverviewCtrl', ["CashupSets", "$filter", "$scope", "$q", "reporttime", "PosTenders", "title", function(CashupSets, $filter, $scope, $q, reporttime, PosTenders, title) {
  title.set('Reconciliation Overview');

  $scope.cashupCols = [
    {label: 'Time', type: 'string', key: 'label'},
    {label: 'Total Variance', type: 'number', key: 'totalVariance', filter: 'currency'}
  ];

  $scope.cashNonCashCols = [
    {label: 'Type', type: 'string', key: 'label'},
    {label: 'Amount', type: 'string', key: 'amount', filter: 'currency'}
  ];

  $scope.loading = $q.all({
    tenders: PosTenders.get(reporttime.start(), reporttime.end()),
    cashups: CashupSets.getSummary(reporttime.start(), reporttime.end(), '1:00:00:00')
  });

  var buildTenderTypeTotals = function(tenders) {

    var totalTenders = $filter('sumof')($scope.tenders, 'tenderAmount');

    // Build a map of the total amount and percentage of overall total for
    // each tender type
    return tenders.reduce(function(totals, tender) {
      // Get the current totals record for the current tender type, or create
      // a new one if none exists
      var typeRecord = totals[tender.tenderPosIdentifier] || {
        tender: tender.tenderName,
        tenderIdent: tender.tenderPosIdentifier,
        amount: 0,
        percent: 0
      };

      // bump rolling totals by the amount of the current tender
      typeRecord.amount += tender.tenderAmount;
      typeRecord.percent = totalTenders !== 0 ?
        (typeRecord.amount / totalTenders) * 100 : typeRecord.percent;

      // and then save the updated record
      totals[tender.tenderPosIdentifier] = typeRecord;

      return totals;
    }, {});

  };

  $scope.loading.then(function(result) {
    angular.forEach(result.cashups, function(period) {
      period.label = moment(period.startTime).format('ddd Do');
    });
    $scope.cashupvariances = result.cashups;

    $scope.tenders = result.tenders;

    var tenderTypeTotals = buildTenderTypeTotals($scope.tenders);

    // convert the tender type totals map into a sorted array for rendering
    $scope.allTenderTypesTotals = Object.keys(tenderTypeTotals)
      .map(function(tenderType) {
        return tenderTypeTotals[tenderType];
      })
      .sort(function(a, b) {
        return a.amount > b.amount ? -1 : 0;
      });

    // get overall totals split by cash or non-cash
    $scope.cashVsNonCashColumns = [
      {
        label: 'Cash',
        amount: $scope.tenders.reduce(function(rollingTotal, tender) {
          return tender.tenderIsCash ? rollingTotal + tender.tenderAmount : rollingTotal;
        }, 0)
      },
      {
        label: 'Non-Cash',
        amount: $scope.tenders.reduce(function(rollingTotal, tender) {
          return !tender.tenderIsCash ? rollingTotal + tender.tenderAmount : rollingTotal;
        }, 0)
      }
    ];
  });
}]);
